import { Bio } from "./Bio";
import { ProfileImage } from "./ProfileImage";
import { StatsBox } from "./StatsBox";

const AboutComponents = { Bio, ProfileImage, StatsBox };

export default AboutComponents;
